var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"188.001","height":"188.001","viewBox":"0 0 49.742 49.742"}},[_c('circle',{attrs:{"cx":"80.408","cy":"121.895","r":"24.739","fill":"#999","stroke":"#000","stroke-width":".265","transform":"translate(-55.537 -97.024)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }